<template>
  <a-config-provider :locale="zhCN" :getPopupContainer="getPopupContainer">
    <div
      v-if="isShow"
      v-hmd-mask
      class="mask-container"
      :style="{ 'z-index': zIndex }"
      :class="[!config.hideMask ? 'mask' : '']"
    >
      <component
        v-hmd-popup
        class="ub ub-pc dialog-contain vivify fadeIn"
        :style="styleObj"
        :is="com"
        :params="params"
        @close="closeFn"
        @cancel="cancelFn"
        @confirm="saveFn"
      />
    </div>
  </a-config-provider>
</template>
<script>
import { inject, defineComponent, onMounted, ref, defineAsyncComponent, computed } from "vue";
import zhCN from "ant-design-vue/es/locale/zh_CN";
export default defineComponent({
  directives: {
    "hmd-mask": {
      mounted(el) {
        /* 这个做寻找的时候的标记量 */
        el.classList.add("wc-messagebox__mask---");
        /* init */
        el.classList.add("wc-messagebox__mask-transition---");
        el.classList.add("wc-messagebox__mask-diff---");
        /* 移除以触发变化*/
        setTimeout(() => {
          el.classList.remove("wc-messagebox__mask-diff---");
        }, 50);
      },
    },
    "hmd-popup": {
      mounted(el) {
        /* 这个做寻找的时候的标记量 */
        el.classList.add("wc-messagebox__popup---");
        /* init */
        el.classList.add("wc-messagebox__popup-transition---");
        el.classList.add("wc-messagebox__popup-diff---");
        /* 移除以触发变化*/
        setTimeout(() => {
          el.classList.remove("wc-messagebox__popup-diff---");
        }, 50);
      },
    },
  },
  components: {
  },
  setup() {
    const config = inject("config");
    const isShow = ref(true);
    const zIndex = computed(() => config.zIndex || 1000);
    onMounted(() => {
      prevent();
      const listener = () => {
        isShow.value = false;
      };
      window.addEventListener("hashchange", listener);
      window.addEventListener("popstate", listener);
      window.addEventListener("pagehide", listener);
    });

    const com = defineAsyncComponent(() => config.com);

    const s = (selector) => {
      const selectors = document.querySelectorAll(selector);
      return selectors[selectors.length - 1];
    };

    const preventPageScroll = (e) => {
      return e.preventDefault();
    };

    const prevent = () => {
      document.addEventListener("touchmove", preventPageScroll, false);
    };

    const recover = () => {
      document.removeEventListener("touchmove", preventPageScroll, false);
    };

    const commonAction = () => {
      recover();
      s(".wc-messagebox__mask---").classList.add("wc-messagebox__mask-diff---");
      s(".wc-messagebox__popup---").classList.add("wc-messagebox__popup-leave---");
      // s('.dialog-contain').classList.remove('fadeIn');
      // s('.dialog-contain').classList.add('fadeOut')
      // s('.dialog-contain').classList.remove('popIn');
      // s('.dialog-contain').classList.add('popOut');
      //不加延迟关闭时没有动画，所以要等动画结束后再隐藏调弹窗
      setTimeout(() => {
        isShow.value = false;
      }, 300);
    };
    const getPopupContainer = (node, e) => {
      if (node) {
        let classes =
         ( node.parentNode?.parentNode?.parentNode?.getAttribute?node.parentNode?.parentNode?.parentNode?.getAttribute("class"):'' )+
          " " +
          (node.parentNode?.parentNode?.parentNode?.getAttribute?node.parentNode?.parentNode?.parentNode?.getAttribute("class"):'') +
          " " +
          (node.parentNode?.parentNode?.getAttribute?node.parentNode?.parentNode?.getAttribute("class"):'') +
          " " +
          (node.parentNode?.getAttribute?node.parentNode?.getAttribute("class"):'') +
          " " +
          node.getAttribute("class");
        // console.log('classes',classes)
        if (classes.indexOf("append-to-body") >= 0) {
          return document.body;
        } else if (classes.indexOf("append-to-parentnode") >= 0) {
          return node.parentNode;
        } else if (classes.indexOf("append-to-table") >= 0) {
          let tmp =
            //document.getElementsByClassName("component-table-list-wrapper")[0] ||
            document.getElementsByClassName("a-table")[0];
          // console.log(tmp);
          return tmp;
        } else {
          return node.parentNode;
        }
      }
      return document.body;
    };
    const cancelFn = (e) => {
      commonAction();
      config.cancel && config.cancel(e);
    };

    const saveFn = (e) => {
      commonAction();
      config.confirm && config.confirm({ params: params.value, res: e });
    };

    const closeFn = (e) => {
      commonAction();
      config.close && config.close(e);
    };
    const params = computed(() => {
      return config.params ? config.params : {};
    });
    const styleObj = computed(() => {
      let t = config.style ? config.style : {};
      const top = config.paddingTop ? config.paddingTop + "%" : null;
      if (top) {
        return Object.assign({ top, "z-index": zIndex.value + 1 }, t);
      } else {
        t["z-index"] = zIndex.value + 1;
        t["top"] = "10%";
        return t;
      }
    });
    return {
      closeFn,
      cancelFn,
      saveFn,
      config,
      isShow,
      com,
      params,
      styleObj,
      zIndex,
      zhCN,
      getPopupContainer,
    };
  },
});
</script>
<style scoped lang="scss">
// @import url('vivify.min.css');
.dialog-contain {
  overflow: hidden auto;
  margin: auto;
}

.mask-container {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  box-sizing: border-box;
  background-color: rgba(0, 0, 0, 0);
}
.mask {
  background-color: rgba(0, 0, 0, 0.45);
}

::-webkit-scrollbar {
  width: 12px;
}
.wc-messagebox__mask-transition--- {
  transition: all 0.25s;
}
.wc-messagebox__mask-diff--- {
  opacity: 0 !important;
}

.wc-messagebox__popup-transition--- {
  transition: all 0.25s;
}

.wc-messagebox__popup-diff--- {
  /* 因为用户有时候可能不是将 popup 写在 mask 里面的*/
  opacity: 0 !important;
  /* 因为用户可能已经设置了 popup 的 transform, 通常定位到中心就会这么做 */
  transform: scale(0.6) !important;
}

.wc-messagebox__popup-leave--- {
  opacity: 0 !important;
  transform: scale(0.6) !important;
}
</style>
